// src/App.js
import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
import Nav from "./sections/Nav";
import Footer from "./sections/Footer";
import ScrollToTop from "./components/ScrollToTop";
import { AppRoutes } from "./routes/AppRoutes";

// Fonts
import "@fontsource/geist-sans/100.css";
import "@fontsource/geist-sans/200.css";
import "@fontsource/geist-sans/300.css";
import "@fontsource/geist-sans/400.css";
import "@fontsource/geist-sans/500.css";
import "@fontsource/geist-sans/600.css";
import "@fontsource/geist-sans/700.css";
import "@fontsource/geist-sans/800.css";
import "@fontsource/geist-sans/900.css";
import "@fontsource/bebas-neue";

// Global Styles
import "./styles/landing.css";
import "./styles/solutions.css";
import "./styles/industries.css";
import "./styles/nav.css";

function App() {
  return (
    <Router>
      <Nav />
      <ScrollToTop>
        <AppRoutes />
      </ScrollToTop>
      <Footer />
    </Router>
  );
}

export default App;
